<template>
  <div class="box box-2" :class="{ 'ani-scale': !isMobileSize }" @click="$emit('openVideo', 2)">
    <img class="img-2" :src="img2" alt="" />
    <img class="add-icon" :src="addIcon" alt="" />
    <div class="title">{{ $t('keypalTwo.introduce.desc_3') }}</div>
    <div class="desc">{{ $t('keypalTwo.introduce.desc_5') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['isMobileSize']),
    img2() {
      if (this.$i18n.locale === 'zh') {
        return require('../../assets/images/keypal-two/introduce-2-zh.png');
      }
      return require('../../assets/images/keypal-two/introduce-2.png');
    },
    addIcon() {
      return require('../../assets/images/keypal-two/add-1.png');
    },
  },
};
</script>

<style lang="scss" scoped>
@import url('./card.scss');
.box-2 {
  width: 384px;
  height: 500px;
  

  .img-2 {
    width: 341px;
    height: 327px;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    bottom: 32px;
  }
}

@media screen and (max-width: 1200px) {
  .box-2 {
    width: calc(384 / 1300 * 100vw);
    height: calc(500 / 1300 * 100vw);
    .img-2 {
      width: calc(341 / 1300 * 100vw);
      height: calc(327 / 1300 * 100vw);
    }
  }
}

@media screen and (max-width: 767px) {
  .box-2 {
    width: 276px;
    height: auto;
    .img-2 {
      width: 230px;
      height: 220px;
      position: absolute;
      left: 50%;
      bottom: 72px;
      transform: translateX(-50%);
    }
  }
}
</style>
